import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	PostLoggingAccess,
	PostLoggingAccessModel,
	PostLoggingAccessParams,
} from 'domain/usecases/private/my-hospitalization/post-logging-access';

export class RemotePostLoggingAccess implements PostLoggingAccess {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostLoggingAccessModel>,
	) {}

	async post(params: PostLoggingAccessParams): Promise<PostLoggingAccessModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
